// extracted by mini-css-extract-plugin
export var card = "SectionCard-module--card--02e69";
export var centerCard = "SectionCard-module--centerCard--9f9ef";
export var pricing = "SectionCard-module--pricing--05b43";
export var pricingText = "SectionCard-module--pricingText--883ed";